
define('text!plugins/date/setupTemplate.html',[],function () { return '';});

